const resolvePagingOffset = (pageIndex, pageSize) => {
  return Math.max(pageIndex, 0) * Math.max(pageSize, 1)
}

export { resolvePagingOffset }
